var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  cloneDeep = require('lodash/cloneDeep');

function ParticipantDetailsModal(params) {
  var self = this;

  self.isLoading = ko.observable(false);
  self.errorMessage = ko.observable();

  self.selectedParticipantsToEdit = params.participants;

  self.postUrl = params.postUrl;
  self.isModalActive = params.isModalActive;
  self.enableBatchEditMode = params.enableBatchEditMode;

  self.hasError = ko.computed(function() {
    return !!self.errorMessage() && self.errorMessage().length > 0;
  });

  self.isIE = /*@cc_on!@*/ false || !!document.documentMode;
  self.isEdge = !self.isIE && !!window.StyleMedia;
}

ParticipantDetailsModal.prototype.hasErrors = function() {
  var self = this;
  var approvedHours = self.selectedParticipantsToEdit[0].ApprovedHours;
  var e = false;
  approvedHours.forEach(function(x) {
    if (x.ApprovedHours.hasError()) {
      e = true;
    }
  });
  return e;
};

ParticipantDetailsModal.prototype.confirmChanges = function() {
  var self = this;
  self.errorMessage('');
  var input = {};

  if (self.hasErrors()) {
    self.errorMessage('Please correct marked fields before saving');
  } else {
    self.isLoading(true);
    var approvedHours = cloneDeep(
      self.selectedParticipantsToEdit[0].ApprovedHours
    );
    approvedHours.forEach(function(hours) {
      var val = hours.ApprovedHours();
      hours.ApprovedHours = parseFloat(
        typeof val === 'string' ? val.replace(',', '.') : val
      );
    });

    input = {
      ApprovedHours: approvedHours,
      Comment: self.selectedParticipantsToEdit[0].Comment
    };

    APIHelper.QcPost(
      self.postUrl,
      input,
      function(response) {
        if (!response.SavedData) {
          self.errorMessage(response.ErrorMessage);
        } else {
          self.selectedParticipantsToEdit[0].StatusTexts(
            response.Participant.StatusTexts
          );
          self.selectedParticipantsToEdit[0].ApprovedHours.forEach(function(
            hours
          ) {
            var index = self.selectedParticipantsToEdit[0].ApprovedHours.indexOf(
              hours
            );
            var val = response.Participant.ApprovedHours[index].ApprovedHours;
            if (self.isIE || self.isEdge) {
              val = val.toLocaleString('nb-NO');
            }
            hours.ApprovedHours(val);
          });
          self.isModalActive(false);
        }
        self.isLoading(false);
      },
      function(response) {
        self.errorMessage(response.ErrorMessage);
        self.isLoading(false);
      }
    );
  }
};

module.exports = ParticipantDetailsModal;
